import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { underlineStyle } from './authStyles';

export default function PasswordField(props) {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    return (
        <TextField
            fullWidth
            variant="standard"
            type={show ? 'text' : 'password'}
            {...props}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton size="small" tabIndex={-1} onClick={() => setShow(v => !v)} edge="end" aria-label={t('a11y.togglePassword')}>
                                {show ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
            sx={{ ...underlineStyle, ...(props.sx || {}) }}
        />
    );
}
